import React, { useState } from 'react';
import Navbar from '../../../components/navbar';
import Footer from '../../../components/footer';
import { FaArrowLeft, FaPencilAlt } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'
import { useFirestore } from '../../../hooks/useFirestore';
import { useAlert } from '../../../contexts/alerta';
import InputFile from '../../../components/inputFile';
import { FaXmark } from 'react-icons/fa6';
import { mensagemNovoRelato } from '../../../hooks/useEmail';

export default function NewEsp(params) {
  const [showForm, setShowForm] = useState(false)
  const [showUserForm, setShowUserForm] = useState(false)
  const [showAnonForm, setShowAnonForm] = useState(false)
  const [form, setForm] = useState({
    nome: '',
    email: '',
    telefone: '',
    motivo: '',
    relato: '',
    protocolo: '',
  })
  const [anexos, setAnexos] = useState([])

  const { novoRelato } = useFirestore()
  const nav = useNavigate();
  const { addAlert } = useAlert()

  const handleShowForm = () => {
    setShowForm(true)
    setShowAnonForm(true)
    setShowUserForm(false)
  }

  const handleUserForm = () => {
    setShowUserForm(true)
    setShowAnonForm(false)
    setShowForm(true)
  }

  const handleChangeInput = (value, type) => {
    setForm({ ...form, [type]: value })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    form.anexos = anexos

    novoRelato(form)
      .then(res => {
        mensagemNovoRelato({ idRelato: res.uuid })
        nav('/es/sucesso', { state: { relato: res } })
      })
      .catch((e) => {
        addAlert('¡Ha ocurrido un problema inesperado!', "error")
      })
  }

  const addAnexo = (anexo) => {
    setAnexos([...anexos, anexo])
  }

  const removeAnexo = (id) => {
    setAnexos(
      anexos.filter(a =>
        a.arquivo !== id
      )
    );
  }

  const mascaraTelefone = value => {
    return value
      .replace(/\D/g, '')
      .replace(/(\d{2})(\d)/, '+$1 $2')
      .replace(/(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{5})(\d)/, '$1-$2')
      .replace(/(-\d{4})\d+?$/, '$1')
  }

  return (
    <div >
      <Navbar lang={'esp'} />
      <main className='flex mt-40 flex-col '>
        <section className='lg:w-4/6 md:w-5/6 w-11/12 m-auto'>
          <div className='flex justify-between mb-8'>
            <h1 className='flex text-primary items-center text-3xl gap-4 font-semibold'><FaPencilAlt />HACER REPORTE</h1>
            <a className='flex items-center text-base text-secondary gap-2 font-semibold' href="/en/home">
              <FaArrowLeft />
              <span className='hidden lg:block'>VOLVER</span>
            </a>
          </div>
          <hr className='border-background mb-8' />
          <div className='text-secondary flex flex-col gap-4 text-lg'>
            <p>Por favor, describa la situación. Al realizar su informe, observe los puntos a continuación para que nuestra comunicación sea lo más completa y detallada posible, de esta manera contribuirá a que tengamos éxito en la investigación.</p>
            <p>Por lo tanto, asegúrese de incluir en la descripción de su informe si es posible:</p>
            <ul className='list-disc ml-8'>
              <li><b>Qué:</b> describe la situación o hecho que te gustaría relatar;</li>
              <li><b>Quién:</b> nombre o “apodo” de los involucrados (personas, empresas, testigos);</li>
              <li><b>Cuándo:</b>  fecha exacta o aproximada en que ocurrió, ocurre u ocurrirá el hecho/situación;</li>
              <li><b>Donde:</b> ubicación, sector, área, departamento y unidad de la situación reportada;</li>
              <li><b>Cuánto:</b> si es posible y tener información sobre cantidad, valores, volúmenes, etc;</li>
              <li><b>Evidencias o pruebas:</b> si existen y dónde se encuentran.</li>
            </ul>
            <p>Para seguir el progreso de su informe, puede utilizar el protocolo proporcionado después de enviar el informe.</p>
            <p>Agradecemos su iniciativa y confianza.</p>
          </div>
        </section>
        <section className='lg:w-4/6 md:w-5/6 w-11/12 m-auto mt-8 mb-8' >
          <div className='flex flex-col lg:flex-row gap-8'>
            <button
              style={{ backgroundColor: showUserForm && '#0C4187', color: showUserForm && '#fff' }}
              onClick={() => handleUserForm()}
              className='p-8 border border-background shadow-md rounded-md text-xl font-semibold'
            >
              Si, quiero identificarme
            </button>
            <button
              style={{ backgroundColor: showAnonForm && '#0C4187', color: showAnonForm && '#fff' }}
              onClick={() => handleShowForm()}
              className='p-8 border border-background shadow-md rounded-md text-xl font-semibold'
            >
              No, deseo permanecer en el anonimato
            </button>
          </div>
          <div>
            <form onSubmit={handleSubmit}>
              {showUserForm &&
                <div className='mt-8'>
                  <h1 className='text-primary text-xl font-semibold'>SU DADOS</h1>
                  <h3 className='text-secondary text-lg font-semibold'>RELLENE SUS DATOS PERSONALES</h3>
                  <div className='bg-background p-8 flex flex-col gap-8'>
                    <label htmlFor="name" className='flex flex-col text-xl text-secondary'>Nombre:
                      <input className='text-base font-semibold rounded-md outline-primary p-2' type="text" id='name' placeholder='Nombre' value={form.nome} onChange={e => handleChangeInput(e.target.value, 'nome')} />
                    </label>
                    <div className='flex flex-col lg:flex-row w-full gap-8'>
                      <label htmlFor="email" className='flex flex-col text-xl text-secondary w-full'>Correo Electronico:
                        <input className='text-base font-semibold rounded-md outline-primary p-2' type="email" id='email' placeholder='E-mail' value={form.email} onChange={e => handleChangeInput(e.target.value, 'email')} />
                      </label>
                      <label htmlFor="telefone" className='flex flex-col text-xl text-secondary w-full'>Teléfono:
                        <input className='text-base font-semibold rounded-md outline-primary p-2' type="text" id='telefone' placeholder='Teléfono' value={form.telefone} onChange={e => handleChangeInput(mascaraTelefone(e.target.value), 'telefone')} />
                      </label>
                    </div>
                  </div>
                </div>
              }
              {showForm &&
                <div className='mt-8'>
                  <h1 className='text-primary text-xl font-semibold'>MOTIVOS DE CONTACTO</h1>
                  <h3 className='text-secondary text-lg font-semibold'>MOTIVO DEL INFORME</h3>
                  <div className='bg-background p-8 flex flex-col gap-8'>
                    <select
                      name="motivo"
                      id="motivo"
                      required
                      value={form.motivo}
                      onChange={e => handleChangeInput(e.target.value, 'motivo')}
                      className='font-semibold bg-white rounded-md border-0 bg-transparent p-4 lg:w-1/2 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm'
                    >
                      <option hidden value="">SELECCIONE</option>
                      <option value="elogio">Cumplido</option>
                      <option value="sugestoes">Sugerencias</option>
                      <option value="duvidas">Dudas</option>
                      <option value="solicitacoes">Peticiones</option>
                      <option value="denuncia">Denuncia</option>
                      <option value="reclamacao">Queja</option>
                    </select>
                    <label className='flex flex-col text-xl text-secondary font-semibold' htmlFor="relato">
                      Detalla tu historia:
                      <textarea
                        required
                        name="relato"
                        id="relato"
                        rows="5"
                        value={form.relato} onChange={e => handleChangeInput(e.target.value, 'relato')}
                        className='rounded-md p-1 focus:ring-1 focus:ring-primary focus:outline-primary'
                      ></textarea>
                    </label>
                    <div className="row">
                      <label className='flex flex-col lg:flex-row text-secondary font-semibold justify-between lg:items-center' htmlFor="protocolo">
                        Si este informe tiene relación con otro, inserte aquí el protocolo anterior:
                        <input className='lg:w-1/2 p-4 rounded-md outline-primary' type="text" id='protocolo' value={form.protocolo} onChange={e => handleChangeInput(e.target.value, 'protocolo')} />
                      </label>
                    </div>
                    <div className='text-secondary' >
                      <div>
                        <p><b>Si tiene una imagen de pantalla e foto que pueda contribuir a su informe, envíenoslo.:</b></p>
                        <p>* Extensiones possibleis: jpg,jpeg,png.</p>
                        <p>** Tamaño máximo 5MB</p>
                      </div>
                    </div>
                    <div className='flex flex-col gap-2'>
                      <span className='font-semibold text-primary'>Anexos:</span>
                      {
                        anexos.map((anexo, i) => (
                          <div className='flex items-center gap-3' key={i}>
                            <span className='font-semibold text-primary'>
                              {anexo.nomeArquivo}
                            </span>
                            <span className='hover:cursor-pointer text-warning' onClick={() => removeAnexo(anexo.arquivo)}><FaXmark /></span>
                          </div>
                        ))
                      }
                      <InputFile name={anexos.length + 1} change={addAnexo} label={`Enviar archivo`} />
                    </div>
                  </div>
                  <div className='flex justify-end'>
                    <input type="submit" value="ENVIA" className='px-8 py-4 uppercase text-lg bg-secondary rounded-md mt-8 text-background font-semibold hover:bg-primary hover:text-white hover:cursor-pointer' />
                  </div>
                </div>
              }
            </form>
          </div>
        </section >
      </main >
      <Footer />
    </div >
  )
};
